
import { Paper, TableContainer, Table, TableHead, TableRow, TableCell, TablePagination, TableBody } from "@material-ui/core"
import { makeStyles } from '@material-ui/core/styles'
import { useSelector, useDispatch } from "react-redux"
import { obtenerExtrasAceptadasPaginaAction, obtenerExtrasAceptadasRegistrosAction } from "../../../ducks/extrasContratadosAceptadasDuck"
import ButtonClienteDetalle from "../../../global/ButtonClienteDetalle"
import { onLoadAnction, offLoadAction } from "../../../ducks/loadDuck"
import CheckCircleIcon from '@material-ui/icons/CheckCircle'
import { FormatoFechaIso } from "../../../utils/FormatFecha"
import { formatDinero } from "./../../../utils/formatDinero"
import FPagarItemExtra from "../FPagarItemExtra"
const columns = [
    { id: "referencia", minWidth: 50, align: "center", label: "Referencia" },
    { id: "paquete", minWidth: 50, align: "center", label: "Paquete" },
    { id: "np", minWidth: 50, align: "center", label: "Num Pax" },
    { id: "fechaSalida", minWidth: 50, align: "center", label: "Fecha de Salida" },
    { id: "motivo", minWidth: 50, align: "center", label: "Motivo" },
    { id: "montoAhorrado", minWidth: 50, align: "center", label: "Monto Ahorrado" },
    { id: "cantidad", minWidth: 50, align: "center", label: "Cantidad" },
    { id: "moneda", minWidth: 50, align: "center", label: "Moneda" },
    { id: "operador", minWidth: 50, align: "center", label: "Operador" },
    { id: "pagar", minWidth: 50, align: "center", label: "Pagar" },
]

const useStyles = makeStyles({
    containerRoot: {
        marginTop: "25px",
        marginBottom: "25px"
    },
    containerRootButton: {
        marginTop: "25px",
        marginBottom: "25px",
        display: "flex",
        justifyContent: "flex-end",
        alignItems: "center"
    },
    root: {
        width: '100%',
        padding: '0'
    },
    container: {
        maxHeight: 440,
    },
})

const TExtras = () => {
    const { listExtrasItemsAceptadas, total, pagina, registros } = useSelector(store => store.extrasContratadosAprobados)
    console.log("🚀 ~ TExtras ~ listExtrasItemsAceptadas:", listExtrasItemsAceptadas)
    const rows = listExtrasItemsAceptadas ?? []
    const classes = useStyles()
    const dispatch = useDispatch()
    const handleChangePage = (event, newPage) => {
        dispatch(onLoadAnction({ message: "" }))
        dispatch(obtenerExtrasAceptadasPaginaAction({ Pagina: newPage })).then(Response => {
            dispatch(offLoadAction())
        })
    }
    const handleChangeRowsPerPage = (event) => {
        dispatch(onLoadAnction({ message: "" }))
        dispatch(obtenerExtrasAceptadasRegistrosAction({ Registros: +event.target.value })).then(Response => {
            dispatch(offLoadAction())
        })
    }

    return (
        <div className={classes.containerRoot}>
            <Paper className={classes.root}>
                <TableContainer className={classes.container}>
                    <Table stickyHeader aria-label="sticky table">
                        <TableHead>
                            <TableRow>
                                {columns.map((column) => (
                                    <TableCell
                                        key={column.id}
                                        align={column.align}
                                        style={{ minWidth: column.minWidth }}
                                    >
                                        {column.label}
                                    </TableCell>
                                ))}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {rows.map((row, index) => {
                                return (
                                    <TableRow hover role="checkbox" tabIndex={-1} key={row.idCompra}>
                                        <TableCell align='center'>
                                            <ButtonClienteDetalle referencia={row.meta?.Referencia} />
                                        </TableCell>
                                        <TableCell align='center'>
                                            {`${row.paquete?.Nombre}`}
                                        </TableCell>
                                        <TableCell align="center">
                                            {`${row.paquete?.Numero_Personas}`}
                                        </TableCell>
                                        <TableCell align="center">
                                            {`${row.paquete?.Fecha_Viaje.split("T")[0]}`}
                                        </TableCell>
                                        <TableCell align="center">
                                            {`${row.TipoCompra?.Descripcion}`}
                                        </TableCell>
                                        <TableCell align="center">
                                            {`${formatDinero(row.paquete?.Cotizacion?.Suma)}`}
                                        </TableCell>
                                        <TableCell align="center">
                                            {`${formatDinero(row.MontoProveedor)}`}
                                        </TableCell>
                                        <TableCell align="center">
                                            {`${row.moneda?.Clave}`}
                                        </TableCell>
                                        <TableCell align="center">
                                            {`${row.paquete?.Proveedor}`}
                                        </TableCell>
                                        <TableCell align="center">
                                            <div style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: "10px" }}>
                                                <FPagarItemExtra Compra={row} />
                                            </div>
                                        </TableCell>
                                    </TableRow>
                                )
                            })}
                        </TableBody>
                    </Table>
                </TableContainer>
                <TablePagination
                    rowsPerPageOptions={[10, 25, 100]}
                    component="div"
                    count={total}
                    rowsPerPage={registros}
                    page={pagina}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                />
            </Paper>
        </div>
    )
}
export default TExtras